const PRODUCT_IMAGE_URL = '/images/monitoring-mock/free-preview-product.png';

type KeywordRank = {
  keyword: string;
  rank: number;
  status: 'up' | 'down' | 'stay';
  range: number;
};

const createKeywordRanking = ({ keyword, rank, status, range }: KeywordRank) => ({
  Keyword: keyword,
  Rank: rank,
  PagePosition: rank > 0 ? `${rank}위 (1페이지 ${rank}번째)` : '',
  RankingChangedStatus: status,
  RankingChangedRange: status === 'down' ? -Math.abs(range) : Math.abs(range),
});

const monitoringDays = [
  {
    date: '2026-05-04T00:00:00',
    price: 19000,
    ranks: [
      { keyword: '2color', rank: 43, status: 'up', range: 5 },
      { keyword: '겨울양말', rank: 12, status: 'up', range: 3 },
      { keyword: '기모양말', rank: 7, status: 'up', range: 2 },
      { keyword: '고신축 융털', rank: 128, status: 'down', range: 4 },
    ],
  },
  {
    date: '2026-05-03T00:00:00',
    price: 18500,
    ranks: [
      { keyword: '2color', rank: 48, status: 'down', range: 3 },
      { keyword: '겨울양말', rank: 15, status: 'down', range: 2 },
      { keyword: '기모양말', rank: 9, status: 'down', range: 3 },
      { keyword: '고신축 융털', rank: 124, status: 'up', range: 6 },
    ],
  },
  {
    date: '2026-05-02T00:00:00',
    price: 15000,
    ranks: [
      { keyword: '2color', rank: 45, status: 'up', range: 7 },
      { keyword: '겨울양말', rank: 13, status: 'up', range: 5 },
      { keyword: '기모양말', rank: 6, status: 'up', range: 4 },
      { keyword: '고신축 융털', rank: 130, status: 'down', range: 2 },
    ],
  },
  {
    date: '2026-05-01T00:00:00',
    price: 12000,
    ranks: [
      { keyword: '2color', rank: 52, status: 'down', range: 4 },
      { keyword: '겨울양말', rank: 18, status: 'down', range: 4 },
      { keyword: '기모양말', rank: 10, status: 'down', range: 5 },
      { keyword: '고신축 융털', rank: 128, status: 'up', range: 8 },
    ],
  },
  {
    date: '2026-04-30T00:00:00',
    price: 17000,
    ranks: [
      { keyword: '2color', rank: 48, status: 'up', range: 11 },
      { keyword: '겨울양말', rank: 14, status: 'up', range: 6 },
      { keyword: '기모양말', rank: 5, status: 'up', range: 8 },
      { keyword: '고신축 융털', rank: 136, status: 'down', range: 5 },
    ],
  },
  {
    date: '2026-04-29T00:00:00',
    price: 21500,
    ranks: [
      { keyword: '2color', rank: 59, status: 'down', range: 8 },
      { keyword: '겨울양말', rank: 20, status: 'down', range: 1 },
      { keyword: '기모양말', rank: 13, status: 'down', range: 1 },
      { keyword: '고신축 융털', rank: 131, status: 'up', range: 3 },
    ],
  },
  {
    date: '2026-04-28T00:00:00',
    price: 30000,
    ranks: [
      { keyword: '2color', rank: 51, status: 'up', range: 4 },
      { keyword: '겨울양말', rank: 19, status: 'up', range: 7 },
      { keyword: '기모양말', rank: 12, status: 'up', range: 3 },
      { keyword: '고신축 융털', rank: 134, status: 'down', range: 6 },
    ],
  },
  {
    date: '2026-04-27T00:00:00',
    price: 36000,
    ranks: [
      { keyword: '2color', rank: 47, status: 'down', range: 2 },
      { keyword: '겨울양말', rank: 10, status: 'down', range: 5 },
      { keyword: '기모양말', rank: 5, status: 'up', range: 8 },
      { keyword: '고신축 융털', rank: 140, status: 'up', range: 2 },
    ],
  },
  {
    date: '2026-04-26T00:00:00',
    price: 31500,
    ranks: [
      { keyword: '2color', rank: 49, status: 'stay', range: 0 },
      { keyword: '겨울양말', rank: 15, status: 'up', range: 2 },
      { keyword: '기모양말', rank: 13, status: 'down', range: 1 },
      { keyword: '고신축 융털', rank: 138, status: 'stay', range: 0 },
    ],
  },
] as const;

export const MOCK_GOODS = [
  {
    SellerId: 'membership-preview',
    StoreName: '예시상품',
    GoodsNo: 'membership-monitoring-preview',
    GoodsName: '남성/여성 고신축 융털 통파일 양말 2color 기모양말',
    GoodsPrice: 790,
    GoodsUrl: 'https://smartstore.naver.com/sellerbox/products/membership-preview',
    GoodsImageUrl: PRODUCT_IMAGE_URL,
    CategoryFullName: '패션잡화 > 양말/스타킹 > 기모양말/발열양말',
    RelatedKeyword: ['2color', '겨울양말', '기모양말', '고신축 융털'],
    RegisteredDate: '2026-05-04T00:00:00',
    PriceChangedStatus: '변화있음',
    SalesChangedStatus: '동일',
    RankingChangedStatus: '변화있음',
    NoticeYn: 'N',
    UseYn: 'Y',
    IsRemovedGoods: false,
    IsSellerboxProduct: false,
    IsIncompleteGoods: false,
    ComparisonGoodsUrl: '',
    ShippingFee: 3000,
    GoodsRegisterDate: '2023-02-03T00:00:00',
    IsMyStoreGoods: false,
    IsDisplayStopped: false,
    MallSeq: 0,
    MonitoringGoodsDetailDailyList: monitoringDays.map((day) => ({
      MonitoringDate: day.date,
      MonitoringGoodsPrice: day.price,
      MonitoringGoodsName: '남성/여성 고신축 융털 통파일 양말 2color 기모양말',
      MonitoringGoodsImageUrl: PRODUCT_IMAGE_URL,
      MonitoringCategoryFullName: '패션잡화 > 양말/스타킹 > 기모양말/발열양말',
      MonitoringRecent3DaySalesCount: 0,
      MonitoringRecent6MonthSalesCount: 0,
      RankingChangedCount: day.ranks.filter((rank) => rank.status !== 'stay').length,
      RelatedKeywordsRanking: day.ranks.map(createKeywordRanking),
      PriceChangedStatus: 'stay',
      SalesChangedStatus: 'stay',
      MonitoringTotalReviewCount: 128,
      MonitoringTotalReviewCountChangedRange: 0,
      MonitoringReviewScore: 4.8,
      MonitoringReviewCountList: [
        { Score: 5, Count: 96, ChangedRange: 0 },
        { Score: 4, Count: 24, ChangedRange: 0 },
        { Score: 3, Count: 6, ChangedRange: 0 },
        { Score: 2, Count: 1, ChangedRange: 0 },
        { Score: 1, Count: 1, ChangedRange: 0 },
      ],
    })),
  },
];
